export default __webpack_public_path__ + "static/media/gallery06.296b9df0.webp";